<template>
  <v-dialog v-model="openFilter" persistent max-width="450">
    <v-card>
      <v-card-title>Filters</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-select v-model="filters.kind" :items="form.productKindSelect" label="Product Kind" dense outlined hide-details multiple></v-select>
          </v-col>
        </v-row>
        
        <v-row>
          <v-col>
            <v-select v-model="filters.tariff" item-text="name" item-value="value" :items="tariffFilter" label="Tariff" :no-data-text="getAllTariffsLoading?'Loading...':'No tariffs found for product kind'" :loading="getAllTariffsLoading" dense outlined hide-details multiple @click="getAllTariffs({ version: '' })"></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-autocomplete v-model="filters.status" :items="form.productStatusSelect" label="Status" dense outlined hide-details multiple></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-autocomplete v-model="filters.statusReason" :items="form.productStatusReasons" label="Status reason" :loading="getStaticDataLoading" dense outlined hide-details multiple></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-select v-model="filters.upgradeStatus" :items="form.upgradeStatus" label="Upgrade status" dense outlined hide-details multiple></v-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-tooltip top max-width="430">
              <span>To activate VoIP version filter, select VoIP in product kind field</span>
              <template v-slot:activator="{ on }">
                <div v-on="disableIfNotVoip ? on : ''">
                  <v-select :disabled="disableIfNotVoip" v-model="version" :items="form.voipVersionSelect" label="VoIP Version" dense outlined hide-details multiple></v-select>
                </div>
              </template>
            </v-tooltip>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <v-switch dense v-model="filters.outOfContract" class="mb-0" label="Out of contract" :true-value="moment().format('YYYY-MM-DD')" false-value=""></v-switch>
            <v-switch dense v-model="filters.outOfPromo" class="my-0" label="Out of promo period" :true-value="moment().format('YYYY-MM-DD')" false-value=""></v-switch>
            <v-divider></v-divider>
            <div>
              <v-row>
                <v-col>
                  <span class="subtitle-2 font-weight-bold">VoIP Migration</span>
                </v-col>
              </v-row>
              <v-tooltip top max-width="430">
                <span>To activate VoIP migration filters, select VoIP in product kind field</span>
                <template v-slot:activator="{ on }">
                  <v-row no-gutters v-on="disableIfNotVoip ? on : ''">
                    <v-col cols="6">
                      <v-switch dense v-model="filters.hardware" :disabled="disableIfNotVoip" true-value="true" false-value="" class="my-0" label="Hardware"></v-switch>
                      <v-switch dense v-model="filters.headset" :disabled="disableIfNotVoip" true-value="true" false-value="" class="my-0" label="Headset"></v-switch>
                      <v-switch dense v-model="filters.ownPhoneSetup" :disabled="disableIfNotVoip" true-value="true" false-value="" class="my-0" label="Own phone setup"></v-switch>
                      <v-switch dense v-model="filters.ipex" :disabled="disableIfNotVoip" true-value="true" false-value="" class="my-0" label="Ipex"></v-switch>
                      <v-switch dense v-model="filters.callRecording" :disabled="disableIfNotVoip" true-value="true" false-value="" class="my-0" label="Call recording"></v-switch>
                      <v-switch dense v-model="filters.international" :disabled="disableIfNotVoip" true-value="true" false-value="" class="my-0" label="International"></v-switch>
                    </v-col>

                    <v-col cols="6">
                      <v-switch dense v-model="filters.audio" :disabled="disableIfNotVoip" true-value="true" false-value="" class="my-0" label="Audio"></v-switch>
                      <v-switch dense v-model="filters.nonGeo" :disabled="disableIfNotVoip" true-value="true" false-value="" class="my-0" label="Non geo"></v-switch>
                      <v-switch dense v-model="filters.crmConnect" :disabled="disableIfNotVoip" true-value="true" false-value="" class="my-0" label="Crm connect"></v-switch>
                      <v-switch dense v-model="filters.phoneDelivery" :disabled="disableIfNotVoip" true-value="true" false-value="" class="my-0" label="Phone delivery"></v-switch>
                      <v-switch dense v-model="filters.numberPort" :disabled="disableIfNotVoip" true-value="true" false-value="" class="my-0" label="Number port"></v-switch>
                    </v-col>
                  </v-row>
                </template>
              </v-tooltip>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn color="warning" small outlined @click="clearForm()">Clear</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="submitForm(filters)">Filter</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    openFilter: {
      type: Boolean,
      default: false
    },
  },

  data () {
    return {
      moment,
      menu: false,
      form: {
        tariffSelect: [],
        outOfContract: false,
        outOfPromo: false,
        productKindSelect: [
          { text: "Telco", value: "telco" },
          { text: "VoIP", value: "voip" },
          { text: "Web", value: "web" },
        ],
        productStatusSelect: [
          {text: 'Inbound', value: 'Inbound'},
          {text: 'Google', value: 'Google'},
          {text: 'MBW', value: 'MBW'},
          {text: 'Warm', value: 'Warm'},
          {text: 'Index', value: 'Index'},
          {text: 'Lost', value: 'Lost'},
          {text: 'Void', value: 'Void'},
          {text: 'For Approval', value: 'For Approval'},
          {text: 'Verification', value: 'Verification'},
          {text: 'DOA', value: 'DOA'},
          {text: 'COT Billing Set Up', value: 'COT Billing Set Up'},
          {text: 'On Hold', value: 'On Hold'},
          {text: 'On Hold - Address Issue', value: 'On Hold - Address Issue'},
          {text: 'On Hold - PAF validation', value: 'On Hold - PAF validation'},
          {text: 'On Hold - Sales Follow-up-Leads', value: 'On Hold - Sales Follow-up-Leads'},
          {text: 'On Hold - Future Live Date', value: 'On Hold - Future Live Date'},
          {text: 'On Hold: Future Live Date', value: 'On Hold: Future Live Date'},
          {text: 'On Hold: Telecoms', value: 'On Hold: Telecoms'},
          {text: 'On Hold: Sales Issue', value: 'On Hold: Sales Issue'},
          {text: 'On Hold: Porting Issue', value: 'On Hold: Porting Issue'},
          {text: 'Porting', value: 'Porting'},
          {text: 'Provisioning', value: 'Provisioning'},
          {text: 'Provisioning Failed', value: 'Provisioning Failed'},
          {text: 'Missed Appointment', value: 'Missed Appointment'},
          {text: 'Provisioned', value: 'Provisioned'},
          {text: 'Order Delay', value: 'Order Delay'},
          {text: 'Cooling Off', value: 'Cooling Off'},
          {text: 'Ready', value: 'Ready'},
          {text: 'Raise Invoice', value: 'Raise Invoice'},
          {text: 'Briefing', value: 'Briefing'},
          {text: 'Re-book Briefing', value: 'Re-book Briefing'},
          {text: 'Being Built', value: 'Being Built'},
          {text: 'Customer Review', value: 'Customer Review'},
          {text: 'Customer Review 2', value: 'Customer Review 2'},
          {text: 'Payment Check', value: 'Payment Check'},
          {text: 'Domain Setup', value: 'Domain Setup'},
          {text: 'Escalation', value: 'Escalation'},
          {text: 'Hold', value: 'Hold'},
          {text: 'Trial', value: 'Trial'},
          {text: 'Trial Expired', value: 'Trial Expired'},
          {text: 'Live and Porting', value: 'Live and Porting'},
          {text: 'Live Briefing', value: 'Live Briefing'},
          {text: 'Live Re-book Briefing', value: 'Live Re-book Briefing'},
          {text: 'Live', value: 'Live'},
          {text: 'Suspended', value: 'Suspended'},
          {text: 'Pending Cancel', value: 'Pending Cancel'},
          {text: 'Cancel', value: 'Cancel'},
          {text: 'Failed', value: 'Failed'},
          {text: 'Upgrade', value: 'Upgrade'},
          {text: 'Legacy Upgrade', value: 'Legacy Upgrade'},
          {text: 'Transfer Stopped', value: 'Transfer Stopped'},
          {text: 'Transfer Out', value: 'Transfer Out'},
          {text: 'Transfer Out Rejected', value: 'Transfer Out Rejected'},
          {text: 'Old Website', value: 'Old Website'},
          {text: 'Pending Dead COT', value: 'Pending Dead COT'},
          {text: 'Dead COT', value: 'Dead COT'},
          {text: 'Dead COP Pending', value: 'Dead COP Pending'},
          {text: 'Dead COP', value: 'Dead COP'},
          {text: 'Fraud', value: 'Fraud'},
          {text: 'Bad Debt', value: 'Bad Debt'},
          {text: 'Blocked Bad Debt ', value: 'Blocked Bad Debt '},
          {text: 'Pending Cease Bad Debt', value: 'Pending Cease Bad Debt'},
          {text: 'Write Off', vaue: 'Write Off'},
          {text: 'Handed Over', value: 'Handed Over'},
          {text: 'Written Off', value: 'Written Off'},
          {text: 'Dead Bad Debt', value: 'Dead Bad Debt'},
        ],
        upgradeStatus: [
          { text: "Not upgraded", value: "Not upgraded" },
          { text: "Upgrade in progress", value: "Upgrade in progress" },
          { text: "Upgraded", value: "Upgraded" },
        ],
        voipVersionSelect: [
          { text: "Version 1.0", value: "TARIFF_V1,TARIFF_V2"},
          { text: "Version 2.0", value: "TARIFF_V3" },
          { text: "Version 3.0", value: "VOIP3" },
        ],
        productStatusReasons: [],
      },
      filters: {
        sortBy: [],
        sortDesc: [],
        tariff: [],
        kind: [],
        status: [],
        statusReason: [],
        upgradeStatus: [],
        version: [],
        supplier: "",
        page:1,
        paginationCount: 0,
        outOfContract: "",
        outOfPromo: "",
        hardware: "",
        headset: "",
        ownPhoneSetup: "",
        ipex: "",
        callRecording: "",
        international: "",
        audio: "",
        nonGeo: "",
        crmConnect: "",
        phoneDelivery: "",
        numberPort: ""
      },
      version: [],
    }
  },

  watch: {
    getAllTariffsList: {
      immediate: true,
      deep: true,
      handler(oldVal, newVal) {
        if(oldVal || newVal) {
          this.form.tariffSelect = this.getAllTariffsList.sort((a, b) => a.name.localeCompare(b.name));
        }
      }
    },

    version: {
      deep: true,
      handler(val) {
        if(val.includes("VOIP3")) {
          this.filters.supplier = "VOIP3";
          this.filters.version = ["TARIFF_V3"];
        } else {
          this.filters.version = val;
          this.filters.supplier = "";
        }
      }
    },

    async openFilter(val) {
      if (val) {
        await this.fetchStaticData({ field__in: ['doa_reason', 'suspended_reason'], kind__in: ['VOIP', 'WEB', 'TELCO'] });
        this.form.productStatusReasons = this.getStaticData.reduce((arr, reason)=> {
          if (!arr.includes(reason.value)) {
            arr.push(reason.value);
          }
          return arr;
        }, []);
      }
    }
  },

  computed: {
    ...mapGetters("products", ["getAllTariffsList", "getAllTariffsLoading"]),
    ...mapGetters('staticData', ['getStaticData', 'getStaticDataLoading']),

    tariffFilter() {
      if(this.filters.kind.length === 0) return this.form.tariffSelect;
      return this.form.tariffSelect.filter(e => {
        let kind = e.product_kind.toLowerCase();
        if(kind === 'voipseat') { kind = "voip" };
        return kind === this.filters.kind;
      });
    },

    disableIfNotVoip() {
      let disabled = false;
      if(this.filters.kind.includes('telco') || this.filters.kind.includes('web')) {
        disabled = true;
        // eslint-disable-next-line
        this.filters.version = [];
        this.filters.hardware = "",
        this.filters.headset = "",
        this.filters.ownPhoneSetup = "",
        this.filters.ipex = "",
        this.filters.callRecording = "",
        this.filters.international = "",
        this.filters.audio = "",
        this.filters.nonGeo = "",
        this.filters.crmConnect = "",
        this.filters.phoneDelivery = "",
        this.filters.numberPort = ""
        this.version = [];
      }
      if(this.filters.kind.length === 0) {
        disabled = true;
      }
      return disabled;
    }
  },

  methods: {
    ...mapActions("productList", ["filterProductList","updateProductListPagination"]),
    ...mapActions("products", ["getAllTariffs"]),
    ...mapActions('staticData', ['fetchStaticData']),

    closeDialog(){
      this.$emit('closeDialog');
    },

    clearForm() {
      this.filters.kind = [];
      this.filters.status = [];
      this.filters.statusReason = [];
      this.filters.upgradeStatus = [];
      this.filters.version = [];
      this.filters.supplier = "";
      this.filters.tariff = [];
      this.filters.hardware = "";
      this.filters.headset = "";
      this.filters.ownPhoneSetup = "";
      this.filters.ipex = "";
      this.filters.callRecording = "";
      this.filters.international = "";
      this.filters.audio = "";
      this.filters.nonGeo = "";
      this.filters.crmConnect = "";
      this.filters.phoneDelivery = "";
      this.filters.numberPort = "";
      this.outOfContract = "";
      this.outOfPromo = "";
      this.version = [];
    },

    submitForm(filters) {
      this.updateProductListPagination(filters);
      this.$emit('closeDialog', false);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
